/**
 * ballstories Bücherregal – Storefront page with Customer Account API (OAuth PKCE).
 */
(function () {
  'use strict';

  if (window.__bsBookshelfApp) return;
  window.__bsBookshelfApp = true;

  const STORAGE_KEY = 'bs_br_session_v2';
  const PKCE_KEY = 'bs_br_pkce_v1';
  // Buch aus dem QR-Code der letzten Buchseite. Überlebt den Login-Redirect,
  // damit der Kunde danach bei seinem Buch landet statt in der Liste.
  const HINT_KEY = 'bs_fb_hint';
  const HINT_TTL_MS = 30 * 60 * 1000;
  const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const BOOKS_CACHE_KEY = 'bs_br_books_cache_v1';
  const DETAIL_CACHE_PREFIX = 'bs_br_detail_v1_';
  const CACHE_TTL_MS = 15 * 60 * 1000;

  const el = document.getElementById('bs-buecherregal');
  const root = document.getElementById('bs-br-root');
  const heroActions = document.getElementById('bs-br-hero-actions');
  const logoutBtn = document.getElementById('bs-br-logout');
  const loadingOverlay = document.getElementById('bs-br-loading-overlay');
  const loadingText = document.getElementById('bs-br-loading-text');
  if (!el || !root) return;

  let overlayEl = loadingOverlay;
  let overlayTextEl = loadingText;

  function injectLoadingStyles() {
    if (document.getElementById('bs-loading-overlay-styles')) return;
    const style = document.createElement('style');
    style.id = 'bs-loading-overlay-styles';
    style.textContent =
      '.bs-loading-overlay{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:1.5rem;background:rgba(255,255,255,.45);backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px)}' +
      '.bs-loading-overlay[hidden]{display:none!important}' +
      'body.bs-loading-overlay-open{overflow:hidden}' +
      '.bs-loading-overlay__card{display:flex;flex-direction:column;align-items:center;gap:.875rem;max-width:20rem;text-align:center}' +
      '.bs-loading-overlay__spinner{--bs-loader-track:#e5e7eb;--bs-loader-accent:#16a34a;--bs-loader-size:1px;width:calc(48*var(--bs-loader-size));height:calc(48*var(--bs-loader-size));border:calc(5*var(--bs-loader-size)) solid var(--bs-loader-track);border-bottom-color:var(--bs-loader-accent);border-radius:50%;display:inline-block;box-sizing:border-box;animation:bs-loading-spin 1s linear infinite}' +
      '.bs-loading-overlay__text{margin:0;font-family:Comfortaa,system-ui,sans-serif;font-size:.9375rem;font-weight:500;color:#6b7280;text-align:center}' +
      '@keyframes bs-loading-spin{to{transform:rotate(360deg)}}';
    document.head.appendChild(style);
  }

  function ensureLoadingOverlay() {
    injectLoadingStyles();
    if (overlayEl) return overlayEl;

    overlayEl = document.createElement('div');
    overlayEl.id = 'bs-br-loading-overlay';
    overlayEl.className = 'bs-loading-overlay';
    overlayEl.hidden = true;
    overlayEl.setAttribute('aria-hidden', 'true');
    overlayEl.innerHTML =
      '<div class="bs-loading-overlay__card" role="status" aria-live="polite" aria-busy="true">' +
      '<span class="bs-loading-overlay__spinner" aria-hidden="true"></span>' +
      '<p class="bs-loading-overlay__text" id="bs-br-loading-text">Wird geladen …</p>' +
      '</div>';
    document.body.appendChild(overlayEl);
    overlayTextEl = overlayEl.querySelector('#bs-br-loading-text');
    return overlayEl;
  }

  function showLoading(message) {
    ensureLoadingOverlay();
    if (overlayTextEl) overlayTextEl.textContent = message || 'Wird geladen …';
    overlayEl.hidden = false;
    overlayEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bs-loading-overlay-open');
  }

  function hideLoading() {
    if (!overlayEl) return;
    overlayEl.hidden = true;
    overlayEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bs-loading-overlay-open');
  }

  const config = {
    shopDomain: el.dataset.shopDomain || '',
    clientId: el.dataset.clientId || '',
    fnBase: (el.dataset.fnBase || '').replace(/\/$/, ''),
    createUrl: el.dataset.createUrl || '/products/fussball-kinderbuch',
    shelfImageUrl: el.dataset.shelfImageUrl || '',
    redirectUri: el.dataset.redirectUri || window.location.origin + window.location.pathname,
    loggedInStorefront: el.dataset.loggedInStorefront === 'true',
  };

  let books = [];
  let view = 'list';
  let detail = null;
  let activeDetailId = null;
  let routeSyncing = false;
  // Why the list came back empty, when the server could tell us.
  let listReason = null;
  let starting = new Set();
  let discovery = null;

  function getRouteFromHash() {
    const raw = (window.location.hash || '').replace(/^#/, '').trim();
    if (raw.startsWith('buch/')) {
      const bookId = decodeURIComponent(raw.slice(5).split(/[/?&]/)[0] || '');
      if (bookId) return { name: 'detail', bookId };
    }
    return { name: 'list' };
  }

  function hashForRoute(name, bookId) {
    return name === 'detail' ? `#buch/${encodeURIComponent(bookId)}` : '#liste';
  }

  function setRouteHash(name, bookId, replace) {
    const hash = hashForRoute(name, bookId);
    const url = window.location.pathname + window.location.search + hash;
    if (window.location.pathname + window.location.search + window.location.hash === url) return;
    routeSyncing = true;
    if (replace) history.replaceState({ bsBr: 1 }, '', url);
    else history.pushState({ bsBr: 1 }, '', url);
    routeSyncing = false;
  }

  async function syncRouteFromHash() {
    if (routeSyncing) return;

    const route = getRouteFromHash();
    const session = loadSession();
    const authenticated = session && (isSessionValid(session) || session.refreshToken);

    if (heroActions) heroActions.hidden = !authenticated;

    if (!authenticated) {
      view = 'list';
      detail = null;
      activeDetailId = null;

      // Wer im Shop schon angemeldet ist, muss hier nicht erneut auf einen
      // Knopf drücken: Shopify erkennt die bestehende Sitzung und schickt den
      // Kunden ohne E-Mail-Code zurück. Der Klick war reine Zeremonie.
      // Nur ein Versuch pro Tab — schlägt er fehl, erscheint das normale Gate
      // statt einer Weiterleitungsschleife.
      if (config.loggedInStorefront && !autoLoginAttempted()) {
        markAutoLoginAttempted();
        showLoading('Deine Bücher werden geladen …');
        startLogin().catch((e) => {
          console.error('[bs-buecherregal] Auto-Login fehlgeschlagen', e);
          hideLoading();
          root.innerHTML = renderGate();
          bindGateEvents();
        });
        return;
      }

      root.innerHTML = renderGate();
      bindGateEvents();
      return;
    }

    if (route.name === 'detail') {
      await openDetail(route.bookId);
      return;
    }

    await openList();
  }

  async function openList() {
    view = 'list';
    detail = null;
    activeDetailId = null;

    if (restoreBooksFromCache() || books.length) {
      renderListView();
      return;
    }

    showLoading('Deine Bücher werden geladen …');
    try {
      await loadBooks({ forceNetwork: true });
      renderListView();
    } catch (e) {
      if (e.message === 'not_authenticated' || e.status === 401) {
        clearSession();
        books = [];
        setRouteHash('list', null, true);
        root.innerHTML = `
          <div class="bs-br__login">
            ${renderError('Anmeldung konnte nicht bestätigt werden. Bitte erneut versuchen.')}
            <button type="button" class="bs-btn bs-btn--primary" id="bs-br-login-btn">Erneut anmelden</button>
          </div>
        `;
        document.getElementById('bs-br-login-btn')?.addEventListener('click', () =>
          handleGateAction().catch(console.error)
        );
        return;
      }
      root.innerHTML = renderError('Bücher konnten nicht geladen werden. Bitte Seite neu laden.');
    } finally {
      hideLoading();
    }
  }

  async function openDetail(bookId) {
    if (!bookId) {
      setRouteHash('list', null, true);
      await openList();
      return;
    }

    // The QR hint has done its job once the customer is at the book. Keeping it
    // would re-personalise the login gate and re-route later visits in this tab.
    if (readBookHint() === bookId) clearBookHint();

    if (view === 'detail' && activeDetailId === bookId && detail) {
      root.innerHTML = renderDetailView();
      bindDetailEvents();
      return;
    }

    view = 'detail';
    activeDetailId = bookId;
    detail = null;
    root.innerHTML = '';

    const cached = loadDetailCache(bookId);
    if (!cached) showLoading('Details werden geladen …');

    try {
      if (cached) {
        detail = cached;
        root.innerHTML = renderDetailView();
        bindDetailEvents();
      }
      detail = await loadDetail(bookId, { useCache: !cached, forceNetwork: !!cached });
      root.innerHTML = renderDetailView();
      bindDetailEvents();
    } catch (e) {
      // Fall back to the list — but do NOT overwrite it with the error, which
      // is what used to happen: openList() rendered the shelf and the next line
      // wiped it, leaving the customer with an error and nothing else. Show the
      // shelf and put the notice above it, so there is always a way forward.
      console.error('[bs-buecherregal] Detail konnte nicht geladen werden', e);
      setRouteHash('list', null, true);
      await openList();
      const notice = document.createElement('div');
      notice.className = 'bs-br__alert bs-br__alert--error';
      notice.setAttribute('role', 'alert');
      notice.textContent =
        'Die Details ließen sich gerade nicht laden. Tippe das Buch noch einmal an.';
      root.prepend(notice);
    } finally {
      hideLoading();
    }
  }

  // ---------------------------------------------------------------------------
  // PKCE helpers
  // ---------------------------------------------------------------------------
  function randomString(len) {
    const arr = new Uint8Array(len);
    crypto.getRandomValues(arr);
    return Array.from(arr, (b) => ('0' + b.toString(16)).slice(-2)).join('');
  }

  function base64UrlEncode(buffer) {
    const bytes = new Uint8Array(buffer);
    let str = '';
    for (const b of bytes) str += String.fromCharCode(b);
    return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  async function sha256(text) {
    const data = new TextEncoder().encode(text);
    return crypto.subtle.digest('SHA-256', data);
  }

  async function createPkcePair() {
    const arr = new Uint8Array(32);
    crypto.getRandomValues(arr);
    const verifier = base64UrlEncode(arr);
    const challenge = base64UrlEncode(await sha256(verifier));
    return { verifier, challenge };
  }

  // ---------------------------------------------------------------------------
  // Session storage
  // ---------------------------------------------------------------------------
  function loadSession() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  function saveSession(session) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  }

  function clearSession() {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(BOOKS_CACHE_KEY);
    sessionStorage.removeItem(PKCE_KEY);
    clearDetailCache();
  }

  function hasStoredSession() {
    const session = loadSession();
    return !!(session?.accessToken || session?.refreshToken);
  }

  // Merker für den automatischen Login. sessionStorage, nicht localStorage:
  // Ein neuer Tab darf es wieder versuchen, derselbe Tab nicht endlos.
  const AUTO_LOGIN_KEY = 'bs_br_autologin_v1';

  function autoLoginAttempted() {
    try {
      return sessionStorage.getItem(AUTO_LOGIN_KEY) === '1';
    } catch {
      // Ohne sessionStorage lieber nicht automatisch weiterleiten — sonst
      // entsteht bei jedem Rendern eine neue Weiterleitung.
      return true;
    }
  }

  function markAutoLoginAttempted() {
    try {
      sessionStorage.setItem(AUTO_LOGIN_KEY, '1');
    } catch {}
  }

  function sessionMarker() {
    const session = loadSession();
    if (!session) return null;
    const token = session.refreshToken || session.accessToken;
    return token ? String(token).slice(-20) : null;
  }

  function loadBooksCache() {
    try {
      const raw = localStorage.getItem(BOOKS_CACHE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (data.marker !== sessionMarker()) return null;
      if (Date.now() - data.fetchedAt > CACHE_TTL_MS) return null;
      return Array.isArray(data.books) ? data.books : null;
    } catch {
      return null;
    }
  }

  function saveBooksCache(list) {
    const marker = sessionMarker();
    if (!marker) return;
    localStorage.setItem(
      BOOKS_CACHE_KEY,
      JSON.stringify({ marker, fetchedAt: Date.now(), books: list })
    );
  }

  function clearDetailCache() {
    try {
      for (let i = localStorage.length - 1; i >= 0; i -= 1) {
        const key = localStorage.key(i);
        if (key && key.startsWith(DETAIL_CACHE_PREFIX)) localStorage.removeItem(key);
      }
    } catch {
      /* ignore */
    }
  }

  function loadDetailCache(bookId) {
    try {
      const raw = localStorage.getItem(DETAIL_CACHE_PREFIX + bookId);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (data.marker !== sessionMarker()) return null;
      if (Date.now() - data.fetchedAt > CACHE_TTL_MS) return null;
      return data.detail || null;
    } catch {
      return null;
    }
  }

  function saveDetailCache(bookId, detailData) {
    const marker = sessionMarker();
    if (!marker || !bookId) return;
    localStorage.setItem(
      DETAIL_CACHE_PREFIX + bookId,
      JSON.stringify({ marker, fetchedAt: Date.now(), detail: detailData })
    );
  }

  function isSessionValid(session) {
    if (!session?.accessToken) return false;
    if (!session.expiresAt) return true;
    return Date.now() < session.expiresAt - 60_000;
  }

  // ---------------------------------------------------------------------------
  // Discovery + OAuth
  // ---------------------------------------------------------------------------
  async function getOpenIdConfig() {
    if (discovery) return discovery;
    const res = await fetch(`https://${config.shopDomain}/.well-known/openid-configuration`);
    if (!res.ok) throw new Error('OpenID discovery failed');
    discovery = await res.json();
    return discovery;
  }

  async function startLogin(loginHint) {
    const oidc = await getOpenIdConfig();
    const { verifier, challenge } = await createPkcePair();
    const state = randomString(16);
    sessionStorage.setItem(
      PKCE_KEY,
      JSON.stringify({ verifier, state, redirectUri: config.redirectUri })
    );

    const url = new URL(oidc.authorization_endpoint);
    url.searchParams.set('scope', 'openid email customer-account-api:full');
    url.searchParams.set('client_id', config.clientId);
    url.searchParams.set('response_type', 'code');
    url.searchParams.set('redirect_uri', config.redirectUri);
    url.searchParams.set('state', state);
    url.searchParams.set('code_challenge', challenge);
    url.searchParams.set('code_challenge_method', 'S256');
    url.searchParams.set('locale', 'de');
    // Vom Kunden eingegebene Adresse mitgeben: Shopify füllt sein eigenes
    // E-Mail-Feld damit vor, sodass sie nur einmal getippt werden muss.
    if (loginHint) url.searchParams.set('login_hint', loginHint);
    window.location.href = url.toString();
  }

  async function exchangeCode(code) {
    const pkceRaw = sessionStorage.getItem(PKCE_KEY);
    if (!pkceRaw) throw new Error('PKCE state missing');
    const pkce = JSON.parse(pkceRaw);

    const res = await fetch(`${config.fnBase}/caapiTokenExchange`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        grantType: 'authorization_code',
        shopDomain: config.shopDomain,
        clientId: config.clientId,
        code,
        redirectUri: pkce.redirectUri || config.redirectUri,
        codeVerifier: pkce.verifier,
      }),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Token exchange failed');
    return data;
  }

  async function refreshAccessToken(refreshToken) {
    const res = await fetch(`${config.fnBase}/caapiTokenExchange`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        grantType: 'refresh_token',
        shopDomain: config.shopDomain,
        clientId: config.clientId,
        refreshToken,
      }),
    });
    const data = await res.json();
    if (!res.ok) {
      const err = new Error(data.error || 'Refresh failed');
      err.status = res.status;
      throw err;
    }
    return data;
  }

  // A refresh that fails with 400/401 means the refresh token itself is dead —
  // only then is the session really gone. Anything else (network, timeout,
  // upstream hiccup) is transient and must not cost the customer their login.
  function isFatalAuthStatus(status) {
    return status === 400 || status === 401;
  }

  async function ensureAccessToken() {
    let session = loadSession();
    if (session && isSessionValid(session)) return session.accessToken;

    if (session?.refreshToken) {
      try {
        const data = await refreshAccessToken(session.refreshToken);
        session = {
          accessToken: data.access_token,
          // No fallback to the previous id_token: the refresh grant usually
          // does not return one, so keeping the old one ships a token that is
          // older than the access token. The server prefers the id_token, fails
          // to verify it and answers 401 — which used to wipe the session.
          idToken: data.id_token || null,
          refreshToken: data.refresh_token || session.refreshToken,
          expiresAt: data.expires_in ? Date.now() + data.expires_in * 1000 : null,
        };
        saveSession(session);
        return session.accessToken;
      } catch (e) {
        if (isFatalAuthStatus(e.status)) clearSession();
        return null;
      }
    }
    return null;
  }

  // ---------------------------------------------------------------------------
  // QR deep link
  // ---------------------------------------------------------------------------

  // Accepts the book id straight off the URL too, so this keeps working if the
  // /my redirect is ever pointed at the shelf instead of the folgebuch page.
  function captureBookIdFromUrl() {
    let raw = '';
    try {
      raw = (new URLSearchParams(window.location.search).get('bookid') || '').trim();
    } catch {
      return;
    }
    if (!raw || !UUID_RE.test(raw)) return;
    try {
      sessionStorage.setItem(HINT_KEY, JSON.stringify({ bookId: raw, ts: Date.now() }));
    } catch {}
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('bookid');
      const search = url.searchParams.toString();
      window.history.replaceState(
        {},
        '',
        url.pathname + (search ? `?${search}` : '') + `#buch/${encodeURIComponent(raw)}`
      );
    } catch {}
  }

  function readBookHint() {
    try {
      const raw = sessionStorage.getItem(HINT_KEY);
      if (!raw) return null;
      const hint = JSON.parse(raw);
      if (!hint?.bookId || !UUID_RE.test(hint.bookId)) return null;
      if (!hint.ts || Date.now() - hint.ts > HINT_TTL_MS) {
        sessionStorage.removeItem(HINT_KEY);
        return null;
      }
      return hint.bookId;
    } catch {
      return null;
    }
  }

  function clearBookHint() {
    try {
      sessionStorage.removeItem(HINT_KEY);
    } catch {}
  }

  // Strip the OAuth handshake params. Leaving them in means every reload
  // re-enters handleOAuthCallback with a verifier that is already consumed,
  // and it keeps the auth code in history, bookmarks and analytics referrers.
  const OAUTH_PARAMS = ['code', 'state', 'error', 'error_description'];

  function cleanOAuthParamsFromUrl(hash) {
    const url = new URL(window.location.href);
    OAUTH_PARAMS.forEach((p) => url.searchParams.delete(p));
    const search = url.searchParams.toString();
    const clean = url.pathname + (search ? `?${search}` : '') + (hash || window.location.hash);
    window.history.replaceState({}, '', clean);
  }

  async function handleOAuthCallback() {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    if (!code) return false;

    const pkceRaw = sessionStorage.getItem(PKCE_KEY);
    if (!pkceRaw) {
      // Code present but no verifier: the callback was opened in a different
      // tab, or this is a reload of an already-consumed callback. Both are
      // recoverable — clean up and start a fresh handshake instead of
      // stranding the customer on an error screen.
      cleanOAuthParamsFromUrl('#liste');
      await startLogin();
      return false;
    }

    const pkce = JSON.parse(pkceRaw);
    if (pkce.state && state && pkce.state !== state) {
      throw new Error('OAuth state mismatch');
    }

    const data = await exchangeCode(code);
    saveSession({
      accessToken: data.access_token,
      idToken: data.id_token || null,
      refreshToken: data.refresh_token || null,
      expiresAt: data.expires_in ? Date.now() + data.expires_in * 1000 : null,
    });
    sessionStorage.removeItem(PKCE_KEY);
    // Login hat geklappt — Merker zuruecksetzen, damit ein spaeterer
    // Sessionablauf wieder automatisch anmelden darf.
    try { sessionStorage.removeItem(AUTO_LOGIN_KEY); } catch {}

    // Came in via QR: go straight to that book instead of dropping the customer
    // into the list to search for what they are already holding.
    const hinted = readBookHint();
    cleanOAuthParamsFromUrl(hinted ? `#buch/${encodeURIComponent(hinted)}` : '#liste');
    return true;
  }

  // ---------------------------------------------------------------------------
  // API calls
  // ---------------------------------------------------------------------------
  async function apiPost(path, body, options) {
    const opts = options || {};
    // Deliberately no forced refresh on the retry. A 401 is often the server's
    // cold start (its JWKS cache is empty and the id_token cannot be verified
    // yet), not a dead token — and the refresh grant returns no new id_token,
    // so forcing one would send the retry off WITHOUT the id_token and make the
    // second attempt fail for certain. Plain repeat: by then the server is warm.
    const token = await ensureAccessToken();
    if (!token) throw new Error('not_authenticated');

    // Read the session *after* ensureAccessToken: a refresh in there writes a
    // new session, so reading it earlier would send a stale id_token along.
    const session = loadSession();

    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
    if (session?.idToken) {
      headers['X-CAAPI-Id-Token'] = session.idToken;
    }

    const res = await fetch(`${config.fnBase}/${path}`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ ...body, shopDomain: config.shopDomain }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      // A single failure is not proof that the login is gone. The most common
      // cause is the function's own cold start: its JWKS cache is empty, the
      // id_token cannot be verified and identity resolution returns 401 — the
      // very next call, against the now-warm instance, succeeds. Wait briefly
      // and repeat once before throwing the customer back into the e-mail flow.
      if (!opts.retried && (res.status === 401 || res.status >= 500)) {
        await new Promise((resolve) => setTimeout(resolve, 400));
        return apiPost(path, body, { retried: true });
      }
      if (res.status === 401) {
        clearSession();
      }
      const err = new Error(data.error || `API error ${res.status}`);
      err.status = res.status;
      err.data = data;
      throw err;
    }
    return data;
  }

  async function loadBooks(options) {
    const opts = options || {};
    const hadBooks = books.length > 0;

    if (opts.useCache !== false) {
      const cached = loadBooksCache();
      if (cached && cached.length) {
        books = cached;
        if (!opts.forceNetwork) return books;
      }
    }

    const data = await apiPost('listCustomerBooksPublic', {});
    const fresh = Array.isArray(data.books) ? data.books : [];
    // The account is valid but could not be mapped to any order. That is a
    // different situation from "no books yet" and needs its own explanation.
    listReason = data.reason || null;
    // Hintergrund-Refresh: leere Antwort nicht über bestehende Liste drüberbügeln.
    if (fresh.length || !hadBooks) {
      books = fresh;
      saveBooksCache(books);
    }
    return books;
  }

  async function loadDetail(bookId, options) {
    const opts = options || {};
    if (opts.useCache !== false) {
      const cached = loadDetailCache(bookId);
      if (cached) {
        if (!opts.forceNetwork) return cached;
      }
    }

    const data = await apiPost('getCustomerBookPublic', { bookId });
    saveDetailCache(bookId, data);
    return data;
  }

  async function startFolgebuch(bookId) {
    if (starting.has(bookId)) return;
    starting.add(bookId);
    showLoading('Folgebuch wird vorbereitet …');
    try {
      const data = await apiPost('folgebuchStartPublic', { bookId });
      if (data.redirectUrl) {
        window.location.href = data.redirectUrl;
        return;
      }
      hideLoading();
      starting.delete(bookId);
      render();
    } catch (e) {
      console.error('[bs-buecherregal] Folgebuch start failed', e);
      hideLoading();
      starting.delete(bookId);
      render();
    }
  }

  // ---------------------------------------------------------------------------
  // Rendering helpers (port from Buecherregal.tsx / MeinKonto.vue)
  // ---------------------------------------------------------------------------
  function badgeLabel(cls) {
    if (cls === 'status-versand') return 'Versand';
    if (cls === 'status-druck') return 'In Druck';
    return 'In Arbeit';
  }

  function buildSeries(list) {
    const byId = new Map(list.map((b) => [b.id, b]));
    const sorted = [...list].sort((a, b) => a.createdAtMs - b.createdAtMs);
    const used = new Set();
    const series = [];
    const roots = sorted.filter((b) => !b.parentBookId || !byId.has(b.parentBookId));
    for (const r of roots) {
      if (used.has(r.id)) continue;
      const chain = [r];
      used.add(r.id);
      let current = r;
      for (;;) {
        const next = sorted.find((x) => x.parentBookId === current.id && !used.has(x.id));
        if (!next) break;
        chain.push(next);
        used.add(next.id);
        current = next;
      }
      series.push(chain);
    }
    for (const b of sorted) {
      if (!used.has(b.id)) {
        used.add(b.id);
        series.push([b]);
      }
    }
    return series;
  }

  function groupByChild(list) {
    const map = new Map();
    for (const b of list) {
      const key = b.childKey || b.id;
      if (!map.has(key)) {
        map.set(key, { displayName: b.childDisplayName || b.childName || '', books: [] });
      }
      map.get(key).books.push(b);
    }
    const sections = [...map.values()];
    sections.sort((a, b) => {
      const am = Math.min(...a.books.map((x) => x.createdAtMs || 0));
      const bm = Math.min(...b.books.map((x) => x.createdAtMs || 0));
      return am - bm;
    });
    return sections;
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderCard(book, clickable) {
    const badge = book.badge || {};
    const coverHtml =
      book.showCover && book.coverUrl
        ? `<img src="${escapeHtml(book.coverUrl)}" alt="${escapeHtml(book.title)}" class="bs-br__card-img" loading="lazy" />`
        : `<span class="bs-br__card-placeholder-text">Cover noch nicht verfügbar</span>`;

    const tag = clickable ? 'a' : 'div';
    const attrs = clickable
      ? `href="${hashForRoute('detail', book.id)}" class="bs-br__card bs-br__card--clickable" data-book-id="${escapeHtml(book.id)}"`
      : `class="bs-br__card bs-br__card--placeholder"`;

    return `
      <${tag} ${attrs}>
        <div class="bs-br__card-cover${book.showCover && book.coverUrl ? '' : ' bs-br__card-cover--placeholder'}">
          ${coverHtml}
          <div class="bs-br__card-cover-title" aria-hidden="true">
            <span class="bs-br__card-cover-line1">${escapeHtml(book.headtitle)}</span>
            <span class="bs-br__card-cover-line2">${escapeHtml(book.titleLine2)}</span>
          </div>
          <span class="bs-br__badge ${escapeHtml(badge.class || '')}">${escapeHtml(badge.label || badgeLabel(badge.class))}</span>
          ${clickable ? '<div class="bs-br__card-overlay"><span>Details →</span></div>' : '<div class="bs-br__card-overlay"><span>In Bearbeitung</span></div>'}
        </div>
      </${tag}>
    `;
  }

  function renderList() {
    if (!books.length) {
      // Someone who has ordered but whose account e-mail we cannot map must not
      // be told they have no books — they would assume their order was lost.
      if (listReason === 'email_unresolved') {
        return `
          <div class="bs-gate bs-gate--notice">
            <span class="bs-gate__mark" aria-hidden="true">✉️</span>
            <h1 class="bs-gate__title">Zu dieser E-Mail finden wir kein Buch</h1>
            <p class="bs-gate__lead">Zu der Adresse, mit der du angemeldet bist, liegt bei uns keine Bestellung.</p>
            <div class="bs-gate__hint">
              <span aria-hidden="true">💡</span>
              <p>Bestellungen hängen an der Adresse aus der <strong>Bestellbestätigung</strong>. Oft ist das eine andere als die, mit der du hier angemeldet bist.</p>
            </div>
            <button type="button" class="bs-gate__cta" id="bs-br-switch-account">Mit anderer E-Mail anmelden</button>
            <p class="bs-gate__note">Du wirst dabei aus diesem Konto abgemeldet.</p>
            <p class="bs-gate__alt">Noch nichts bestellt? <a href="${escapeHtml(config.createUrl)}">Erstes Buch erstellen</a></p>
          </div>
        `;
      }
      // Kein Vorwurf, kein "leider": ein leeres Regal ist ein Anfang.
      return `
        <div class="bs-gate bs-gate--empty">
          <p class="bs-gate__eyebrow">Dein Regal</p>
          <h1 class="bs-gate__title">Hier ist noch Platz</h1>
          <p class="bs-gate__lead">Sobald dein erstes Buch bestellt ist, findest du es hier — mit Status, Details und dem Weg zum nächsten Band.</p>
          <div class="bs-gate__shelf" aria-hidden="true">
            <span class="bs-gate__slot"></span>
            <span class="bs-gate__slot bs-gate__slot--tall"></span>
            <span class="bs-gate__slot"></span>
            <span class="bs-gate__board"></span>
          </div>
          <a href="${escapeHtml(config.createUrl)}" class="bs-gate__cta">Erstes Buch erstellen ⚽</a>
          <p class="bs-gate__note">In 3 Minuten konfiguriert · 6–8 Werktage bis zum Briefkasten</p>
        </div>
      `;
    }
    const sections = groupByChild(books);

    // Seitenkopf aus den geladenen Büchern: Wer hier ankommt, soll sofort
    // sehen, dass es SEIN Regal ist — nicht eine Produktseite. Bei einem Kind
    // trägt der Kopf den Namen, bei mehreren bleibt er allgemein.
    const single = sections.length === 1 ? sections[0] : null;
    const kidName = single ? single.books[0]?.childName || '' : '';
    const bandCount = books.filter((b) => b.showCover).length || books.length;
    const meta = [
      bandCount === 1 ? '1 Band' : `${bandCount} Bände`,
      single ? kidName : `${sections.length} Kinder`,
    ]
      .filter(Boolean)
      .join(' · ');

    let html = `
      <header class="bs-br__pagehead">
        <p class="bs-br__eyebrow">Dein Regal</p>
        <h1 class="bs-br__pagetitle">${
          single && single.displayName
            ? `${escapeHtml(single.displayName)} Bücherregal`
            : 'Dein Bücherregal'
        }</h1>
        <p class="bs-br__pagemeta">${escapeHtml(meta)}</p>
      </header>
    `;
    html += '<div class="bs-br__shelf">';

    for (const section of sections) {
      const chains = buildSeries(section.books);
      // Ein Buch, auf das ein anderes verweist, ist nicht das Ende seiner Reihe.
      const parentIds = new Set(section.books.map((b) => b.parentBookId).filter(Boolean));
      const displayName = section.displayName || '';
      const plainName = section.books[0]?.childName || '';

      html += '<section class="bs-br__kid">';

      // Überschrift nur bei mehreren Kindern. Bei einem — dem Regelfall —
      // wäre sie eine Zwischenebene ohne Nutzen.
      if (sections.length > 1 && displayName) {
        html += `<h2 class="bs-br__kid-name bs-trademark-skip">${escapeHtml(displayName)} Bücher</h2>`;
      }

      for (const chain of chains) {
        html += '<div class="bs-br__series">';
        chain.forEach((book, i) => {
          // Die Bandnummer trägt die Reihenfolge. Früher standen dafür Pfeile
          // zwischen den Karten — unruhig, und am Kettenende zeigte einer ins Leere.
          html += renderRow(book, chain.length > 1 ? i + 1 : 0);
        });
        html += '</div>';

        const tail = chain[chain.length - 1];
        if (tail.showCover && !parentIds.has(tail.id)) {
          html += `
            <div class="bs-br__next">
              <div class="bs-br__next-text">
                <h3 class="bs-br__next-title">Folgebuch${plainName ? ' für ' + escapeHtml(plainName) : ''}</h3>
                <p class="bs-br__next-hint">Wir übernehmen alles, was wir schon wissen — du änderst nur, was neu ist.</p>
              </div>
              <button type="button" class="bs-br__next-cta" data-folgebuch-id="${escapeHtml(tail.id)}">Weiter zum Konfigurator</button>
            </div>
          `;
        }
      }

      html += '</section>';
    }

    html += `
      <a href="${escapeHtml(config.createUrl)}" class="bs-br__new">
        <span class="bs-br__new-icon" aria-hidden="true">+</span>
        <span class="bs-br__new-label">Neue Buchreihe starten</span>
      </a>
    `;
    html += '</div>';

    // Ausblick: dieselben Kacheln wie im abgemeldeten Zustand. Hoerbuecher
    // waren vorher nur eine schmale Zeile und gingen unter.
    html += `
      <div class="bs-gate__behind bs-gate__behind--shelf">
        <p class="bs-gate__behind-title">Dein Regal kann mehr</p>
        ${renderFeatureGrid()}
      </div>
    `;
    return html;
  }

  function formatShelfDate(ms) {
    if (!ms) return '';
    try {
      return new Date(ms).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
    } catch {
      return '';
    }
  }

  /**
   * Eine Zeile der Buchliste. Kompakt statt Kachel: Die meisten Kunden haben
   * ein bis zwei Bücher, ein Raster sähe dabei leer aus.
   *
   * @param {number} band Bandnummer, 0 wenn die Reihe nur ein Buch hat.
   */
  function renderRow(book, band) {
    const clickable = !!book.showCover;
    const tag = clickable ? 'a' : 'div';
    const href = clickable ? ` href="#buch/${encodeURIComponent(book.id)}"` : '';
    const label = book.titleLine2 || book.title || 'Ohne Titel';
    const line = band ? `Band ${band} — ${escapeHtml(label)}` : escapeHtml(label);
    const date = formatShelfDate(book.createdAtMs);
    const badgeClass = (book.badge && book.badge.class) || '';
    const badgeText = (book.badge && book.badge.label) || badgeLabel(badgeClass);

    const cover = book.coverUrl
      ? `<img class="bs-br__row-cover" src="${escapeHtml(book.coverUrl)}" alt="" width="40" height="52" loading="lazy" decoding="async">`
      : // Noch kein Cover: Das Buch entsteht gerade. Ein Platzhalter, der nach
        // Vorfreude aussieht, nicht nach Fehler.
        '<span class="bs-br__row-cover bs-br__row-cover--pending" aria-hidden="true">📖</span>';

    return `
      <${tag} class="bs-br__row${clickable ? '' : ' bs-br__row--pending'}"${href}>
        ${cover}
        <span class="bs-br__row-text">
          <span class="bs-br__row-title">${line}</span>
          ${date ? `<span class="bs-br__row-date">${escapeHtml(date)}</span>` : ''}
        </span>
        <span class="bs-br__badge ${escapeHtml(badgeClass)}">${escapeHtml(badgeText)}</span>
        ${clickable ? '<span class="bs-br__row-chevron" aria-hidden="true">›</span>' : ''}
      </${tag}>
    `;
  }

  function renderDetailView() {
    if (!detail) return '';
    const d = detail;

    const cover = d.coverUrl
      ? `<div class="bs-bd__cover"><img src="${escapeHtml(d.coverUrl)}" alt="${escapeHtml(d.titleLine2 || '')}" loading="lazy" decoding="async"></div>`
      : '';

    const images = (d.chapterImages || []).length
      ? `
        <section class="bs-bd__block">
          <h3 class="bs-bd__block-title">Bilder aus dem Buch</h3>
          <div class="bs-bd__images">
            ${d.chapterImages.map((u) => `<img src="${escapeHtml(u)}" alt="" loading="lazy" decoding="async">`).join('')}
          </div>
        </section>
      `
      : '';

    // Die Daten kommen als "Label: Wert". Als Chips gelesen trägt der Wert die
    // Information — "Maxi", "FC Dreieich", "Nr. 9". Das Label bleibt für
    // Screenreader und als Tooltip erhalten, damit nichts mehrdeutig wird.
    const facts = (d.sections || [])
      .map((sec) => {
        const chips = (sec.rows || [])
          .map((row) => {
            const i = String(row).indexOf(':');
            const label = i > 0 ? row.slice(0, i).trim() : '';
            const value = i > 0 ? row.slice(i + 1).trim() : String(row).trim();
            if (!value) return '';
            return `<span class="bs-bd__chip" title="${escapeHtml(label || value)}"><span class="bs-bd__chip-label">${escapeHtml(label)}</span>${escapeHtml(value)}</span>`;
          })
          .join('');
        if (!chips) return '';
        return `
          <section class="bs-bd__block">
            <h3 class="bs-bd__block-title">${escapeHtml(sec.emoji || '')} ${escapeHtml(sec.heading || '')}</h3>
            <div class="bs-bd__chips">${chips}</div>
          </section>
        `;
      })
      .join('');

    return `
      <div class="bs-bd">
        <a href="#liste" class="bs-bd__back" id="bs-br-back">← Zurück zum Regal</a>

        ${cover}

        <header class="bs-bd__head">
          <h2 class="bs-bd__title">${escapeHtml(d.titleLine2 || 'Dein Buch')}</h2>
          ${d.headtitle ? `<p class="bs-bd__sub">${escapeHtml(d.headtitle)}</p>` : ''}
          <div class="bs-bd__status">
            <span class="bs-br__badge ${escapeHtml(d.badgeClass || '')}">${escapeHtml(badgeLabel(d.badgeClass))}</span>
            ${d.orderDate ? `<span class="bs-bd__date">Bestellt am ${escapeHtml(d.orderDate)}</span>` : ''}
          </div>
          ${d.trackingUrl ? `<a class="bs-bd__tracking" href="${escapeHtml(d.trackingUrl)}" target="_blank" rel="noopener">Sendung verfolgen →</a>` : ''}
        </header>

        ${d.summary ? `
          <section class="bs-bd__block">
            <h3 class="bs-bd__block-title">Kurz gesagt</h3>
            <p class="bs-bd__summary">${escapeHtml(d.summary)}</p>
          </section>
        ` : ''}

        ${images}
        ${facts}

        <div class="bs-br__soon">
          <span class="bs-br__soon-icon" aria-hidden="true">▶</span>
          <span class="bs-br__soon-label">Hörbuch zu diesem Band</span>
          <span class="bs-br__soon-badge">BALD</span>
        </div>

        ${d.canFolgebuch ? `
          <div class="bs-bd__cta-bar">
            <button type="button" class="bs-br__next-cta" data-folgebuch-id="${escapeHtml(d.id)}">Folgebuch erstellen ⚽</button>
          </div>
        ` : ''}
      </div>
    `;
  }

  /**
   * Der ausgeloggte Zustand — im Shop-Menü verlinkt und damit für viele die
   * erste Begegnung mit dem Bücherregal.
   *
   * Bisher stand hier nur ein Satz und ein Knopf. Die Anmeldung kostet den
   * Kunden einen Schritt; diese Seite muss zeigen, wofür. Deshalb drei Karten,
   * die benennen, was dahinter liegt.
   *
   * Nach einem QR-Scan sieht es anders aus: Dann gibt es einen konkreten
   * Anlass, und der zählt mehr als jede Aufzählung.
   */
  function renderGate() {
    const fromQr = !!readBookHint();

    if (fromQr) {
      return `
        <div class="bs-gate bs-gate--qr">
          <p class="bs-gate__eyebrow">Dein Regal</p>
          <h1 class="bs-gate__title">Nur noch ein Schritt</h1>
          <p class="bs-gate__lead">Dann übernehmen wir alles aus dem Buch, das du gerade in der Hand hältst — Name, Verein, Freunde, Orte.</p>
          ${renderLoginForm('Weiter zum Folgebuch')}
          <p class="bs-gate__note">Wir zeigen erst nach der Anmeldung echte Buchdaten.</p>
        </div>
      `;
    }

    return `
      <div class="bs-gate">
        <header class="bs-gate__head">
          <p class="bs-gate__eyebrow">Mein Bücherregal</p>
          <h1 class="bs-gate__title">Hier stehen die Bücher deines Kindes</h1>
          <p class="bs-gate__lead">Bestellte Bände, Versandstatus und der Weg zum nächsten Abenteuer — sichtbar nach der Anmeldung.</p>
        </header>

        <div class="bs-gate__main">
          ${renderShelfPreview()}

          <div class="bs-gate__login">
            <h2 class="bs-gate__login-title">Regal öffnen</h2>
            <p class="bs-gate__login-lead">Melde dich mit der E-Mail-Adresse aus deiner Bestellung an.</p>
            ${renderLoginForm('Anmelden und Regal öffnen')}
            <span class="bs-gate__rule" aria-hidden="true"></span>
            <div class="bs-gate__alt">
              <p class="bs-gate__alt-title">Noch kein Buch?</p>
              <a class="bs-gate__alt-btn" href="${escapeHtml(config.createUrl)}">Erstes Buch erstellen</a>
              <p class="bs-gate__alt-note">45,00 € · versandkostenfrei · in 6–8 Werktagen da</p>
            </div>
          </div>
        </div>

        <div class="bs-gate__behind">
          <p class="bs-gate__behind-title">Dahinter liegt</p>
          ${renderFeatureGrid()}
        </div>
      </div>
    `;
  }

  /**
   * Ein angedeutetes Regal mit zwei Bänden und einer offenen Lücke.
   *
   * Eine Seite namens Bücherregal muss Bücher zeigen — vorher standen hier nur
   * graue Textkarten. Die Bände sind gezeichnet, nicht echt: Vor der Anmeldung
   * dürfen keine Kundendaten sichtbar sein.
   */
  /**
   * Die vier Kacheln im Muster der uebrigen Website (.bs-feature-card).
   *
   * Abgemeldet erklaeren sie, was hinter der Anmeldung liegt; angemeldet sind
   * sie der Ausblick. Deshalb dieselbe Komponente an beiden Stellen — driftet
   * sonst wieder auseinander.
   */
  function renderFeatureGrid() {
    return `
      <ul class="bs-gate__grid">
        <li class="bs-gate__card">
          <span class="bs-gate__card-icon" aria-hidden="true">📖</span>
          <h3 class="bs-gate__card-title">Deine Bände</h3>
          <p class="bs-gate__card-text">Jedes bestellte Buch mit Status, Versand und allen Details.</p>
        </li>
        <li class="bs-gate__card">
          <span class="bs-gate__card-icon" aria-hidden="true">⚽</span>
          <h3 class="bs-gate__card-title">Das Universum</h3>
          <p class="bs-gate__card-text">Verein, Freunde, Orte und Werte deines Kindes an einem Ort.</p>
        </li>
        <li class="bs-gate__card">
          <span class="bs-gate__card-icon" aria-hidden="true">✨</span>
          <h3 class="bs-gate__card-title">Folgebücher</h3>
          <p class="bs-gate__card-text">Alles Bekannte ist vorbelegt — du änderst nur, was neu ist.</p>
        </li>
        <li class="bs-gate__card bs-gate__card--soon">
          <span class="bs-gate__card-badge">bald</span>
          <span class="bs-gate__card-icon" aria-hidden="true">🎧</span>
          <h3 class="bs-gate__card-title">Hörbücher</h3>
          <p class="bs-gate__card-text">Die Welt deines Kindes zum Anhören. Wir arbeiten daran.</p>
        </li>
      </ul>
    `;
  }

  /**
   * Ein echtes Foto statt gezeichneter Baende.
   *
   * Die gezeichnete Variante stammte aus dem Entwurf, wirkte neben der
   * uebrigen Website aber wie ein Fremdkoerper — dort tragen ueberall echte
   * Fotos. Das Bild ist dasselbe, das die Startseite schon zeigt.
   */
  function renderShelfPreview() {
    return `
      <figure class="bs-shelf-preview">
        <img
          class="bs-shelf-preview__photo"
          src="${escapeHtml(config.shelfImageUrl)}"
          alt="Kind hält zwei personalisierte ballstories Bücher"
          width="560" height="700" loading="eager" decoding="async"
        >
        <figcaption class="bs-shelf-preview__caption">Beispiel — dein eigenes Regal erscheint nach der Anmeldung.</figcaption>
      </figure>
    `;
  }

  /**
   * E-Mail-Feld plus Anmelde-Knopf.
   *
   * Den Code verschickt Shopify, nicht wir — ein eigener Magic Link hieße eine
   * zweite Anmeldung neben der bestehenden. Die eingegebene Adresse wird aber
   * als `login_hint` mitgegeben, und Shopify füllt sein Feld damit vor. Der
   * Kunde tippt sie also genau einmal. Leer lassen geht auch.
   */
  function renderLoginForm(label) {
    return `
      <form class="bs-gate__form" id="bs-br-login-form" novalidate>
        <input
          type="email"
          class="bs-gate__input"
          id="bs-br-email"
          name="email"
          autocomplete="email"
          inputmode="email"
          placeholder="E-Mail aus deiner Bestellung"
          aria-label="E-Mail-Adresse aus deiner Bestellung"
        >
        <button type="submit" class="bs-gate__cta" id="bs-br-login-btn">${escapeHtml(label)}</button>
      </form>
      <p class="bs-gate__note">Kein Passwort nötig — Shopify schickt dir einen Bestätigungscode.</p>
    `;
  }

  async function handleGateAction(loginHint) {
    const btn = document.getElementById('bs-br-login-btn');
    if (btn) {
      btn.disabled = true;
      btn.textContent = hasStoredSession() ? 'Bücher werden geladen …' : 'Weiterleitung …';
    }
    if (hasStoredSession()) {
      showLoading('Deine Bücher werden geladen …');
      await initAuthenticated();
      return;
    }
    await startLogin(loginHint);
  }

  function restoreBooksFromCache() {
    if (books.length) return true;
    const cached = loadBooksCache();
    if (Array.isArray(cached) && cached.length) {
      books = cached;
      return true;
    }
    return false;
  }

  function renderListView() {
    root.innerHTML = renderList();
    bindListEvents();
  }

  async function ensureListLoaded() {
    setRouteHash('list', null, true);
    await openList();
  }

  function render() {
    syncRouteFromHash().catch(console.error);
  }

  function renderError(msg) {
    return `<div class="bs-br__alert bs-br__alert--error" role="alert">${escapeHtml(msg)}</div>`;
  }

  /** Verdrahtet das Anmeldeformular im Gate. */
  function bindGateEvents() {
    const form = document.getElementById('bs-br-login-form');
    if (!form) return;
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const value = (document.getElementById('bs-br-email')?.value || '').trim();
      handleGateAction(value).catch(console.error);
    });
  }

  function bindListEvents() {
    root.querySelectorAll('[data-folgebuch-id]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-folgebuch-id');
        if (id) startFolgebuch(id);
      });
    });

    root.querySelector('#bs-br-switch-account')?.addEventListener('click', () => {
      clearSession();
      startLogin().catch(console.error);
    });
  }

  function bindDetailEvents() {
    root.querySelectorAll('[data-folgebuch-id]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-folgebuch-id');
        if (id) startFolgebuch(id);
      });
    });
  }

  async function initAuthenticated() {
    const cached = loadBooksCache();
    if (cached?.length) {
      books = cached;
      if (heroActions) heroActions.hidden = false;
      hideLoading();

      loadBooks({ forceNetwork: true })
        .then(() => {
          if (view === 'list') renderListView();
        })
        .catch((e) => {
          if (e.message !== 'not_authenticated' && e.status !== 401) {
            console.warn('[bs-buecherregal] Hintergrund-Aktualisierung fehlgeschlagen', e);
          }
        });

      await syncRouteFromHash();
      return;
    }

    showLoading('Deine Bücher werden geladen …');
    try {
      await loadBooks({ forceNetwork: true });
      if (heroActions) heroActions.hidden = false;
      await syncRouteFromHash();
    } catch (e) {
      if (e.message === 'not_authenticated' || e.status === 401) {
        clearSession();
        root.innerHTML = `
          <div class="bs-br__login">
            ${renderError('Anmeldung konnte nicht bestätigt werden. Bitte erneut versuchen.')}
            <button type="button" class="bs-btn bs-btn--primary" id="bs-br-login-btn">Erneut anmelden</button>
          </div>
        `;
        document.getElementById('bs-br-login-btn')?.addEventListener('click', () => handleGateAction().catch(console.error));
        return;
      }
      root.innerHTML = renderError('Bücher konnten nicht geladen werden. Bitte Seite neu laden.');
    } finally {
      hideLoading();
    }
  }

  logoutBtn?.addEventListener('click', () => {
    clearSession();
    // Bewusst abgemeldet: in diesem Tab nicht automatisch wieder anmelden.
    markAutoLoginAttempted();
    view = 'list';
    detail = null;
    activeDetailId = null;
    books = [];
    listReason = null;
    setRouteHash('list', null, true);
    syncRouteFromHash().catch(console.error);
  });

  window.addEventListener('hashchange', () => {
    syncRouteFromHash().catch(console.error);
  });
  window.addEventListener('popstate', () => {
    syncRouteFromHash().catch(console.error);
  });

  (async function bootstrap() {
    // Before anything else: a ?bookid from the QR code must be captured and
    // stripped, so it survives the login redirect and never lands in history.
    captureBookIdFromUrl();

    try {
      const hadCallback = await handleOAuthCallback().catch((e) => {
        console.error('[bs-buecherregal] OAuth callback error', e);
        hideLoading();
        // Clean the params here too, otherwise every reload replays the same
        // failing exchange and the customer never gets past this screen.
        cleanOAuthParamsFromUrl('#liste');
        root.innerHTML = renderError('Anmeldung fehlgeschlagen. Bitte erneut versuchen.');
        return false;
      });

      if (hadCallback) {
        showLoading('Anmeldung wird abgeschlossen …');
        await initAuthenticated();
        return;
      }

      await syncRouteFromHash();
    } catch (e) {
      console.error('[bs-buecherregal] init failed', e);
      root.innerHTML = renderError('Ein Fehler ist aufgetreten.');
    }
  })();
})();
